import Apify from '@module/apify';

export default Apify({
  getVersion: {
    path: '/api/v4/meta/compatibility-version',
    method: 'GET',
  },
});
